<!--
  @description: 发票管理
  @filePath:src/modules/transport/bms/views/finance/invoiceManage/Index.vue
-->
<template>
    <paper class="invoice-manage">
        <m-pane
                ref="tablePage"
                :config="config"
                :totalData="totalData"
                :pageTotal="pageTotal"
                :loading="loading"
                :searchTotalTitle="config.searchTotalTitle"
                :currentPage="currentPage"
                searchId="invoiceManage"
                pageID="_invoiceManage"
                @row-db-click="handleRowDBClick"
                @selectChange="handleSelectChange"
                @searchChange="handleSearchChange"
                @pageChange="handlePageChange"
                @sizeChange="handleSizeChange">
        </m-pane>
    </paper>
</template>

<script>
import mPane from '@/components/supplierPanel';
import paper from '@/components/core/paper/Paper';
import mTableMixin from '@/modules/transport/bms/mixins/mTableMixin.js';
import config from './config.js';
import dayjs from 'dayjs';
import { extsysInvoiceQuery, deleteExtsysInvoice } from '@/modules/transport/bms/api/invoiceManageApi.js';

export default {
    name: 'InvoiceManage',
    mixins: [mTableMixin],
    components: { mPane, paper },
    data() {
        return {
            config,
            defaultSearchParams: {
                searchTime: [
                    dayjs().startOf('month').startOf('day').toDate(),
                    dayjs().endOf('month').endOf('day').toDate()
                ],
                startTime: dayjs().startOf('month').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                endTime: dayjs().endOf('month').endOf('day').format('YYYY-MM-DD HH:mm:ss')
            }
        };
    },
    watch: {
        $route: {
            immediate: true,
            handler({ query }, oldValue) {
                if (query.refreshList) {
                    this.queryList();
                }
                if (query.redirectName === 'InvoiceManageDetails') {
                    this.goDetails(JSON.parse(query.redirectParams));
                }
            }
        }
    },
    activated() {
        if (this.$route.query.from === 'todoList') {
            this.handleTodo();
        }
    },
    methods: {
        // 查询发票执行
        queryListExecute({ params, successCallback }) {
            params = this.handleParams(params);
            this.loading = true;
            extsysInvoiceQuery(params).then(res => {
                if (res && +res.code === 0) {
                    successCallback(res);
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        // 双击
        rowDBClickExecute(row) {
            this.goDetails(row);
        },
        // 跳转详情
        goDetails(params) {
            const toParams = JSON.stringify({
                ...params
            });
            this.$router.push({
                name: `InvoiceManageDetails`,
                params: {
                    apApplyData: toParams
                },
                query: { hasInvoice: true, source: 'InvoiceManage' }
            });
        },
        // 删除发票确认执行
        deleteTableConfirmExecute({ params, confirmFn, successCallback }) {
            confirmFn().then(() => {
                deleteExtsysInvoice(params.ids).then(res => {
                    if (res && +res.code === 0) {
                        successCallback();
                    }
                });
            });
        },
        initSearchParamsExecute(params) {
            if (this.$route.query.from === 'todoList') {
                this.handleTodo();
            } else {
                this.searchParams = { ...this.searchParams, ...this.defaultSearchParams };
            };
            this.$nextTick(() => {
                this.$refs.tablePage.$refs.searchList.setQueryParams(this.searchParams);
            });
        },
        handleParams(params) {
            params = this.processTimeParam(this.config.searchList.searchTxt, params);
            params.makeInvoiceStatuses && (params.makeInvoiceStatuses = params.makeInvoiceStatuses.join(','));
            return params;
        },
        // 首页跳转过来 参数处理
        handleTodo() {
            this.$set(this.searchParams, 'makeInvoiceStatuses', ['60', '90']);
            this.$nextTick(() => {
                this.$refs.tablePage.$refs.searchList.setQueryParams({ 'makeInvoiceStatuses': ['60', '90'] });
            });
            this.$router.replace({ query: {} });
        }
    }
};
</script>

<style lang="less">
@import "../../../styles/common.less";
@import "./invoiceManage.less";
</style>
